import {
  generateHash,
  generateMetaData,
  generateMetaDataServerSide,
  getIdentifier,
  makeid,
} from "../util";
import { fetchServiceJson } from "./service-fetch";

export async function getTokenServerSide(identifier) {
  return await fetch("https://pro.ip-api.com/json?key=3pQZfl587vsCBcB").then(
    async (res) => {
      const data = await res.json();
      if (!res.ok) {
        return Promise.reject(data);
      }
      return {
        token: (await getAccessServerSideToken(data, identifier))?.data || null,
        identifier,
        ipDetails: data,
      };
    },
  );
}

export async function getNewToken(identifier) {
  let getToken = null;
  try {
    getToken = await getTokenServerSide(identifier?.value || makeid(8));
  } catch (err) {
    return null;
  }

  if (!getToken) {
    return null;
  }

  if (!getToken.token) return null;

  const { token: newToken } = getToken;
  return newToken.token;
}

export async function getAccessServerSideToken(metaData, identifier) {
  identifier = !identifier ? getIdentifier() : identifier;
  const hash = await generateHash({
    identifier,
    tokenType: "guest",
  });
  return fetchServiceJson("access/token", null, {
    method: "POST",
    data: {
      accessLevel: "regular",
      identifier,
      hash,
      ...generateMetaDataServerSide(metaData),
    },
  })
    .catch((e) => {
      console.log("server side token failed", { e });
    });
}

export async function getAccessToken(metaData) {
  const identifier = getIdentifier();
  const hash = await generateHash({
    identifier,
    tokenType: "guest",
  });
  try {
    return await fetchServiceJson("access/token", null, {
      method: "POST",
      data: {
        identifier,
        accessLevel: "regular",
        hash,
        ...generateMetaData(metaData),
      },
      rejectOnError: true,
    });
  } catch (error) {
    console.error("Failed to fetch in getAccessToken:", error);
    throw error;
  }
}

export async function decodeAccessToken(token) {
  try {
    return await fetchServiceJson("access/decode", null, {
      method: "POST",
      data: {
        token,
        app: "web",
      },
      rejectOnError: true,
    });
  } catch (error) {
    console.error("Failed to fetch in getAccessToken:", error);
    throw error;
  }
}
